import styled from 'styled-components';

export const TimerContainer = styled.div`
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;

    .time {
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
        line-height: 28px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            opacity: 0.5;
        }

        .expired {
            color: ${(props) => props.theme.palette.secondaryA4};
            background-color: #ffeef4;
        }

        ${(props) => props.theme.breakpointTo.sm} {
            background-color: ${(props) => props.theme.palette.primaryA6};
            color: ${(props) => props.theme.palette.primaryA1};
            padding: 8px 12px;
            border-radius: 8px;
            gap: 4px;
            ${(props) => props.theme.typography.textBold};

            svg {
                width: 16px;
                height: 16px;
            }
        }
    }
`;
